import React from 'react';
import { withRouter } from "react-router-dom";

const FloatingSignUp = (props) => {
  return (
    <div className="floating-signup-wrapper" onClick={() => props.history.push('/sign-up')}>
      <span>Sign up</span>
    </div>
  );
};

export default withRouter(FloatingSignUp);
